import { searchIcon } from "../../../assets/icons";
import classNames from "classnames";
import { EMPTY_STRING } from "../../../constants";
import { useEffect, useState } from "react";

const SearchBar = ({ placeholder, handleOnSearch, draggable, filters }) => {
  const [inputValue, setInputValue] = useState(EMPTY_STRING);

  const handleInputChange = (e) => setInputValue(e.target.value);

  useEffect(() => {
    if (!filters?.name) setInputValue(EMPTY_STRING);
  }, [filters]);

  return (
    <div className="relative w-full xs:w-auto">
      <div className="absolute top-1/2 -translate-y-1/2 left-3">
        <img src={searchIcon} className="w-5" alt="search" />
      </div>
      <input
        type="text"
        id="default-search"
        className={classNames(
          "bg-gray-800 border w-full !border-gray-700 rounded-md pl-11 text-gray-300 h-10",
          { "cursor-col-resize": draggable }
        )}
        placeholder={placeholder}
        value={inputValue}
        autoComplete="off"
        onChange={(e) => {
          handleOnSearch(e.target.value);
          handleInputChange(e);
        }}
      />
    </div>
  );
};

export default SearchBar;
